import { createAction, createSlice } from '@reduxjs/toolkit';
import { MessageType } from '../actions/common';
const initState = {
  LC_BUTTON_ENTER: false, // enter键
  LC_BUTTON_TRIANGLE: false, // 三角键
  LC_BUTTON_CIRCLE: false, // 小圆圈键
  LC_BUTTON_CROSS: false, // X键
  LC_BUTTON_SQUARE: false, // 方块
  LC_BUTTON_L1: false, // 左拨片
  LC_BUTTON_R1: false, // 右拨片
  LC_BUTTON_UP: false, // 上
  LC_BUTTON_DOWN: false, // 下
  LC_BUTTON_LEFT: false, // 左
  LC_BUTTON_RIGHT: false, // 右
  LC_BUTTON_MINUS: false, //减号
  LC_BUTTON_R3: false, // R3
  LC_BUTTON_R2: false, // R2
  LC_BUTTON_L2: false, //L2
  LC_BUTTON_L3: false, //L3
  LC_BUTTON_PLUS: false, // +号
};

const controlBtn = createSlice({
  name: 'controlBtn',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(MessageType.STEERING_OPERATE, (state: any, action: any) => {
      const res = action.payload;
      const { steeringOperate } = res || {};
      const { localControlButton } = steeringOperate || [];
      state.LC_BUTTON_ENTER = localControlButton[23];
      state.LC_BUTTON_TRIANGLE = localControlButton[3];
      state.LC_BUTTON_CIRCLE = localControlButton[2];
      state.LC_BUTTON_CROSS = localControlButton[0];
      state.LC_BUTTON_SQUARE = localControlButton[1];
      state.LC_BUTTON_L1 = localControlButton[5];
      state.LC_BUTTON_R1 = localControlButton[4];
      state.LC_BUTTON_UP = localControlButton[24];
      state.LC_BUTTON_DOWN = localControlButton[25];
      state.LC_BUTTON_LEFT = localControlButton[26];
      state.LC_BUTTON_RIGHT = localControlButton[27];
      state.LC_BUTTON_MINUS = localControlButton[20];
      state.LC_BUTTON_R2 = localControlButton[6];
      state.LC_BUTTON_R3 = localControlButton[10];
      state.LC_BUTTON_L2 = localControlButton[7];
      state.LC_BUTTON_L3 = localControlButton[11];
      state.LC_BUTTON_PLUS = localControlButton[19];
    });
  },
});

export default controlBtn.reducer;
